var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[(_vm.loading)?_c('div',{staticClass:"d-flex justify-center"},[_vm._v(" 檔案匯出中，請稍後⋯⋯ ")]):_c('div',{staticClass:"d-flex justify-center"},[_vm._v(" 檔案匯出完成，可以關閉此頁面。 ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }